import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private readonly TOKEN_KEY = 'auth_token';

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  get token(): string | null {
    if (!isPlatformBrowser(this.platformId)) {
      return null;
    }
    return localStorage.getItem(this.TOKEN_KEY);
  }

  setToken(token: string): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.TOKEN_KEY, token);
    }
  }

  removeToken(): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem(this.TOKEN_KEY);
    }
  }

  /**
   * ✅ Para Sanctum: solo verificamos que exista el token
   * No validamos expiración porque Sanctum lo maneja en el backend
   */
  isTokenValid(): boolean {
    const token = this.token;
    return !!token && token.length > 0;
  }

  /**
   * ⚠️ Este método NO funciona con Sanctum (tokens opacos)
   * Solo útil si usaras JWT
   */
  getUserIdFromToken(): number | null {
    // Sanctum usa tokens opacos, no JWT
    // No podemos decodificar información del token
    return null;
  }
}
